/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.fintech.discounts.rpc.PromotionsRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './PromotionsRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.fintech.discounts.rpc.PromotionsRpc#getPromotions
 */
export const GET_PROMOTIONS_QUERY_FIELD_NAME = 'com_hubspot_fintech_discounts_rpc_PromotionsRpc_getPromotions';
export const GET_PROMOTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PROMOTIONS_QUERY_FIELD_NAME,
  args: ['filters', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getPromotionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.fintech.discounts.rpc.PromotionsRpc#getPromotion
 */
export const GET_PROMOTION_QUERY_FIELD_NAME = 'com_hubspot_fintech_discounts_rpc_PromotionsRpc_getPromotion';
export const GET_PROMOTION_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PROMOTION_QUERY_FIELD_NAME,
  args: ['promotionId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getPromotionRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.fintech.discounts.rpc.PromotionsRpc#getEnrolledPromotionsByPortalId
 */
export const GET_ENROLLED_PROMOTIONS_BY_PORTAL_ID_QUERY_FIELD_NAME = 'com_hubspot_fintech_discounts_rpc_PromotionsRpc_getEnrolledPromotionsByPortalId';
export const GET_ENROLLED_PROMOTIONS_BY_PORTAL_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ENROLLED_PROMOTIONS_BY_PORTAL_ID_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getEnrolledPromotionsByPortalIdRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.fintech.discounts.rpc.PromotionsRpc#enrollPortal
 */
export const ENROLL_PORTAL_MUTATION_FIELD_NAME = 'com_hubspot_fintech_discounts_rpc_PromotionsRpc_enrollPortal';
export const ENROLL_PORTAL_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: ENROLL_PORTAL_MUTATION_FIELD_NAME,
  args: ['promotionId', 'expiresAt'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.enrollPortalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.fintech.discounts.rpc.PromotionsRpc#bulkEnrollPortal
 */
export const BULK_ENROLL_PORTAL_MUTATION_FIELD_NAME = 'com_hubspot_fintech_discounts_rpc_PromotionsRpc_bulkEnrollPortal';
export const BULK_ENROLL_PORTAL_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: BULK_ENROLL_PORTAL_MUTATION_FIELD_NAME,
  args: ['promotionId', 'portalIds', 'expiresAt'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.bulkEnrollPortalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});